export default "__VITE_ASSET__F3FAE9Zq__"